import { DataBox } from "./DataBox";
import Print from "./details/Print";

export function SystemOrder() {
    return (
        <>
            <DataBox />
            <Print />
        </>
    );
}

